import { Component, Input, OnInit, SimpleChanges,OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal,NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CreatejobComponent } from '../createjob/createjob.component';
import { JobpropertiesComponent } from '../jobproperties/jobproperties.component';
import { CommonService } from '../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { W700servicesService } from '../services/w700services.service';
import { NewauditComponent } from '../newaudit/newaudit.component';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TabChangeService } from '../services/tab-change.service';

@Component({
  selector: 'app-w700jobslist',
  templateUrl: './w700jobslist.component.html',
  styleUrls: ['./w700jobslist.component.scss']
})

export class W700jobslistComponent implements OnInit, OnDestroy {
  private savePropertiesEventSubscription: Subscription;

  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'w700-jobs';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];

  screenHeight: number;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: CommonService,
    private w700service: W700servicesService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private activeModal: NgbActiveModal,
    private tabChangeService: TabChangeService
  ) { }
  classw700: string = '';
  deploymentkey: string = '';
  searchText: string = '';
  usernamedisplay: string;
  userrole: string = '';
  jobNames: string[] = []; 
  isDeployement: string = "";
  pagerolepermisions: any = '';
  keywordsearch_deployment ="name";

  deployemntlist: any = [];
  private static readonly displayFrequency: { [key: string]: string } = {
    'Seconds': 'S',
    'Minutes': 'M',
    'Hours': 'H',
    'Daily': 'D'
  };

  ngOnInit() {
    this.screenHeight = window.innerHeight - 229;
    this.getdeploymentconfiguration();
    this.savePropertiesEventSubscription = this.w700service.savePropertiesEvent.subscribe(
      (data: string) => {
        this.onKeyUpSearchJobslist(data);
        window.location.reload();

      }
    );
    
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
    // this.classw700 = 'mat-list-item ng-star-inserted active';
    // if (await this.service.checksession() == true) {
    //   var rolepermissinslist = JSON.parse(sessionStorage.getItem('rolepermissions'));
    //   this.pagerolepermisions = rolepermissinslist.filter(c => c.module == 'w700')[0];
    // }

    // if (this.router.url.includes("w700jobslist")) {
    //   this.classw700 = 'mat-list-item ng-star-inserted active';
    // }
    // else {
    //   this.classw700 = '';
    // }

    // if (await this.service.checksession() == true) {
    //   this.usernamedisplay = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['FormattedDisplayName'];
    //   this.userrole = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['role'];
    //   var rolepermissinslist = JSON.parse(sessionStorage.getItem('rolepermissions'));
    //   this.pagerolepermisions = rolepermissinslist.filter(c => c.module == 'w700')[0];
    //   if (this.pagerolepermisions != undefined) {
    //     this.route.queryParams.subscribe(
    //       params => {
    //         this.deploymentkey = params['deploymentkey'];
    //       }
    //     )
    //   }
    // }
  }

  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    if (this.savePropertiesEventSubscription) {
      this.savePropertiesEventSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }

  getdeploymentconfiguration() {
    this.service.getDeployments("Deployments").subscribe(
      data => {
        if (data.length > 0) {
          this.deployemntlist= data;
        } else if (data.length === 0) {
          this.deployemntlist = [];
        }
    },error=>{
      this.ngxUiLoaderService.stop()
    })
  }

 
  isLoadingResult: boolean = false;
  ChangeDeployment(event) {
 
    if ( event !== "") {
      this.isDeployement = event.name
      //this.onKeyUpSearchJobslist(this.searchtext)
    }
  }

  searchDeplyoementCleared(){
    this.isDeployement ="";
    // this.w700jobslist =[];
    this.searchText ="";
  }

  onKeyUpSearchJobslist(event: any) {

    var val = event;
    this.searchtext = val;
    if (Number(val.length) + Number(1) > 2 || val ==='') {
      this.ngxUiLoaderService.start()
      this.w700jobslist=[]
      let deployement =  typeof(this.isDeployement)=="string"||typeof(this.isDeployement)==undefined? this.isDeployement:this.isDeployement['name'];
      // this.w700service.getapiurl("api/W700Jobs/GetW700ApplicationJobs?searchvalue=" + val, deployement).subscribe(response => {
      //   if (response['status'] && response['statusText']) {
      //   }
      //   else {
      //     this.ngxUiLoaderService.stop()
      //     this.w700jobslist = response as any[];
      //     if (this.w700jobslist.length > 0) {
      //       this.datashow = true;
      //     }
      //     else {
      //       this.datashow = false;
      //     }
      //   }
      // },error=>{
      //   this.ngxUiLoaderService.stop()
      // })
      var apiname = "api/VitalHubDXAPI/GetW700ApplicationJobs?searchvalue=" + val;
    
      this.w700service.getapi(apiname, deployement).subscribe({
        next: data => {
          this.w700jobslist = data as any[];
          this.jobNames = this.w700jobslist.map(job => job.JobName); 
          this.datashow = this.w700jobslist.length > 0;
          if(this.w700jobslist.length <= 0)
          {
            this.toastr.error( 'W700 Jobs Not Found ', "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
          this.ngxUiLoaderService.stop();
        },
        error: error => {
          this.ngxUiLoaderService.stop();
        }
      });
    } else {
      this.w700jobslist = [];
      this.datashow = false;
    }
  }
  datashow: boolean = false;
  w700jobslist: any = [];

  // numbers = [];
  // noOfPages: number;
  // pageSize = 10;
  // currentPage = 0;
  // setPage(value) {
  //   this.currentPage = value;
  // }
  // setPagePrev() {
  //   if (this.currentPage != 0) {
  //     this.currentPage = this.currentPage - 1;
  //   }
  // }
  // setPageNext() {
  //   if (this.currentPage < this.noOfPages - 1) {
  //     this.currentPage = this.currentPage + 1;
  //   }
  // }

  public dataToModal: any;
  openCreateJobpopup(item) {
    
    this.dataToModal = {
      deploymentkey: typeof(this.isDeployement)=="string"||typeof(this.isDeployement)==undefined? this.isDeployement:this.isDeployement['name'],
      dataitem: {
        ...item,
        OperationValue: item.OperationValue === "" ? item.ClassName : item.OperationValue
      }
    }
    const createJobModalRef = this.modalService.open(CreatejobComponent,
      { windowClass: "myCustomModalClassjob", backdrop: 'static', keyboard: false, size: 'lg', });
    createJobModalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
    this.currentModalRefs.push(createJobModalRef);
    
    createJobModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== createJobModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== createJobModalRef);
      }
    );
    
    // modalRef.result.then(() => {
    //    this.onKeyUpSearchJobslist(this.searchtext);
    // });
    createJobModalRef.componentInstance.jobContent.subscribe((data: string) => {
    //  this.onKeyUpSearchJobslist(data);  
    this.activeModal.close(); 
  });
    
    this.tagW700JobModal();
    this.modalWasOpen = true;
  }
  searchtext: string = '';

  openpropertiesJobpopup(item) {
    
    this.dataToModal = {
      deploymentkey: this.isDeployement,
      dataitem: item
    }
    const propertiesModalRef = this.modalService.open(JobpropertiesComponent,
      { windowClass: "myCustomModalClassjob", backdrop: 'static', keyboard: false });
    propertiesModalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
    this.currentModalRefs.push(propertiesModalRef);
    
    propertiesModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== propertiesModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== propertiesModalRef);
      }
    );
    
    propertiesModalRef.componentInstance.jobPropertiesContent.subscribe((data: string) => {
        this.onKeyUpSearchJobslist(data);    
    });
    
    this.tagW700JobModal();
    this.modalWasOpen = true;
  }
  onSearchJobs()
  {
    if (!this.isDeployement) {     
      this.toastr.warning('Deployment is Mandatory', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
      return; 
    }
  
    this.onKeyUpSearchJobslist(this.searchtext || '');
  }
  getstatus(spKey: boolean): string {
    return spKey === true ? 'Active' : 'Inactive';
  }

  getFrequency(frequencyType: string): string {
    if (frequencyType in W700jobslistComponent.displayFrequency) {
      return W700jobslistComponent.displayFrequency[frequencyType];
    }
    return frequencyType; 
  }

  private tagW700JobModal() {
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.myCustomModalClassjob.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-w700jobslist-modal', 'true');
      }
      const backdrops = document.querySelectorAll('.modal-backdrop.show');
      const backdrop = backdrops[backdrops.length - 1] as HTMLElement;
      if (backdrop && !this.isOtherComponentBackdrop(backdrop)) {
        backdrop.setAttribute('data-w700jobslist-modal', 'true');
      }
    }, 100);
  }

  private isOtherComponentBackdrop(backdrop: HTMLElement): boolean {
    return backdrop.hasAttribute('data-hubmessages-modal')
      || backdrop.hasAttribute('data-create-modal')
      || backdrop.hasAttribute('data-interface-modal')
      || backdrop.hasAttribute('data-requestform-modal')
      || backdrop.hasAttribute('data-userrole-modal');
  }

  private getVisibleBackdrops(): HTMLElement[] {
    return Array.from(document.querySelectorAll('.modal-backdrop')).filter(backdrop => {
      const style = window.getComputedStyle(backdrop);
      return style.display !== 'none' && style.display !== '';
    }) as HTMLElement[];
  }

  hideModals() {
    if (!this.currentModalRefs?.length) {
      return;
    }

    const modalElements = Array.from(document.querySelectorAll('.modal.myCustomModalClassjob, .modal[data-w700jobslist-modal="true"]')) as HTMLElement[];
    const visibleModals = modalElements.filter(modal => {
      const style = window.getComputedStyle(modal);
      return modal.classList.contains('show') || (style.display !== 'none' && style.display !== '');
    });

    const nestedModals = Array.from(document.querySelectorAll('#newPopupModal.custom-modal, .custom-modal.show')) as HTMLElement[];
    const visibleNestedModals = nestedModals.filter(modal => {
      const style = window.getComputedStyle(modal);
      return style.display !== 'none' && style.display !== '';
    });

    if (visibleModals.length > 0 || visibleNestedModals.length > 0) {
      this.modalWasOpen = true;

      visibleModals.forEach(modalElement => {
        modalElement.setAttribute('data-w700jobslist-modal', 'true');
        modalElement.style.setProperty('display', 'none', 'important');
      });

      visibleNestedModals.forEach(modalElement => {
        modalElement.setAttribute('data-w700jobslist-modal', 'true');
        modalElement.style.setProperty('display', 'none', 'important');
      });

      let backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-w700jobslist-modal="true"]')) as HTMLElement[];
      if (backdrops.length === 0) {
        backdrops = this.getVisibleBackdrops().filter(backdrop => !this.isOtherComponentBackdrop(backdrop));
        backdrops.forEach(backdrop => backdrop.setAttribute('data-w700jobslist-modal', 'true'));
      }

      backdrops.forEach(backdrop => {
        backdrop.style.setProperty('display', 'none', 'important');
      });

      document.body.classList.remove('modal-open');
    } else {
      this.modalWasOpen = this.currentModalRefs.length > 0;
    }
  }

  showModals() {
    if (this.modalWasOpen && this.currentModalRefs?.length > 0) {
      const modalElements = document.querySelectorAll('.modal.myCustomModalClassjob[data-w700jobslist-modal="true"], .modal[data-w700jobslist-modal="true"]') as NodeListOf<HTMLElement>;
      const nestedModals = document.querySelectorAll('#newPopupModal.custom-modal[data-w700jobslist-modal="true"], .custom-modal[data-w700jobslist-modal="true"]') as NodeListOf<HTMLElement>;
      const backdrops = document.querySelectorAll('.modal-backdrop[data-w700jobslist-modal="true"]') as NodeListOf<HTMLElement>;

      modalElements.forEach(modalElement => {
        modalElement.style.setProperty('display', 'block', 'important');
        if (!modalElement.classList.contains('show')) {
          modalElement.classList.add('show');
        }
      });

      nestedModals.forEach(modalElement => {
        modalElement.style.setProperty('display', 'block', 'important');
        if (!modalElement.classList.contains('show')) {
          modalElement.classList.add('show');
        }
      });

      backdrops.forEach(backdrop => {
        backdrop.style.setProperty('display', 'block', 'important');
        if (!backdrop.classList.contains('show')) {
          backdrop.classList.add('show');
        }
      });

      if (modalElements.length > 0 || nestedModals.length > 0) {
        document.body.classList.add('modal-open');
      }
    }
  }

}
